import React, { forwardRef, useCallback, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import SonatypeLifecycleMappingForm from './SonatypeLifecycleMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

function SonatypeLifecycleCredentialsForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => (
    [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "username",
        label: "Username",
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    }, ...(featureFlags.MANAGE_SBOM ? [{
        name: "ingestSBOM",
        label: "Ingest Components",
        type: FieldTypes.SWITCH,
        help: 'Ingest SBOM and components from the tool projects mapped under this configuration into the supply chain module',
        inline: true,
    }] : [])]
    ),[featureFlags.MANAGE_SBOM])

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            ingestSBOM: config.ingestSBOM === "true"
        };
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            initialValue={{ingestSBOM: featureFlags.MANAGE_SBOM ? false : undefined}}
            MappingForm={SonatypeLifecycleMappingForm}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(SonatypeLifecycleCredentialsForm);